import React from "react";
import { useTranslation } from 'react-i18next';

// Styles
import './style/not_found_ui.scss';


const NotFoundUI = () => {
    const { t } = useTranslation();
    return (
        <div className="not_found_ui">
            <h5 className="not_found_ui_heading">
                404
            </h5>
            <p className="not_found_ui_content">
                {t("Sorry, this page isn't available or you might not have permission to view it.")}
            </p>
        </div>
    );
};

export default NotFoundUI;